import React from 'react';

const AccountOption = ({ option, isSelected, onSelect }) => (
  <div 
    className={`modern-signup-account-option ${isSelected ? 'selected' : ''}`}
    onClick={() => onSelect(option.type)}
  >
    <div className="modern-signup-option-bg"></div>
    <div className="modern-signup-option-header">
      <div className="modern-signup-option-info modern-signup-option-info-flex">
        <h2 className="modern-signup-option-title">{option.title}</h2>
        <p className="modern-signup-option-subtitle">{option.subtitle}</p>
      </div>
      <div className="modern-signup-option-icon">
        <i className={option.icon} style={{ color: '#a3a3a3' }}></i>
      </div>
    </div>
    <ul className="modern-signup-option-features">
      {option.features.map((feature, index) => (
        <li key={index} className="modern-signup-feature-item">
          <div className="modern-signup-feature-check">
            <i className="fas fa-check"></i>
          </div>
          <span className="modern-signup-feature-text">{feature}</span>
        </li>
      ))}
    </ul>
    <button className="modern-signup-option-btn">
      <div className="modern-signup-btn-content">
        <i className={option.icon}></i>
        <span>{option.buttonText}</span>
      </div>
      <div className="modern-signup-btn-shine"></div>
    </button>
  </div>
);

export default AccountOption;
